import { useState } from "react";
import { fetchInsurance } from "../utils/patients/fetchInsurance";
import useProfileStore from "../store/patient/profileStore";
import { fetchPaymentHistory } from "../utils/patients/fetchPaymentHistory";

const useManageBillAndInsurance = () => {

  const [loading, setLoading] = useState(false);
  const [claims, setClaims ] = useState();
  const {profile} = useProfileStore()
  const [payments, setPayments] = useState()

  

  // id = 27503
  const handleInsuranceClaims = async () => {
    try{
      setLoading(true);
      const response = await fetchInsurance(profile?.id)
      
      setClaims(response.data);
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      console.log("error error");
      setLoading(false)
    }
    
  };

  const handlePaymentHistory = async () => {
    try{
      setLoading(true);
      const response = await fetchPaymentHistory(profile?.id)
      
      setPayments(response.data?.result);
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      console.log("error error");
      setLoading(false)
    }
    
  };

  



  return {
    handleInsuranceClaims,
    handlePaymentHistory,
    payments,
    loading,
    claims,
  };
};

export default useManageBillAndInsurance;